// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'align-center';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.68 2.248h14.626M3.93 5.623h10.126M.556 8.998H17.43m-13.5 3.375h10.126M1.68 15.748h14.626'
  />
);

export const viewBox = '0 0 18 18';
